// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3be4f","footer":"ModalCreateQualiphyProcedure_footer__149v9","additionData":"ModalCreateQualiphyProcedure_additionData__3h3Q4"};